import { gql } from '@apollo/client'
import { SABRE_PRODUCT_FRAGMENT } from '../fragments'

export const SABRE_GET_PRODUCTS = gql`
  query GetProducts($input: ProductsInput) {
    products(input: $input) {
      count
      hasMore
      results {
        ...Product
      }
    }
  }
  ${SABRE_PRODUCT_FRAGMENT}
`
